import { render } from "./ViewLegalServicePayment.vue?vue&type=template&id=035c5146"
import script from "./ViewLegalServicePayment.vue?vue&type=script&lang=js"
export * from "./ViewLegalServicePayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__